<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span v-if="$route.name === 'InterlocuteursList'">{{ interlocuteursData.total }} Interlocuteur<span v-if="interlocuteursData.total > 1">s</span></span>
          <span v-else>{{ tiersData.total }} Tiers</span>
        </h1>
      </template>
      <template slot="before-actions">
        <router-link
          :to="{name: 'TiersCreate'}"
          class="page-header-btn is-small is-secondary is-widthFixToHeaderAccount"
          id="tiersCreateButton">
          <span>Créer tiers</span>
        </router-link>
      </template>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="true"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <template slot="left-col-small">
        <col-collapse-filter
          :has-filter="hasFilter"
          @opened="openedCol = !openedCol"
          @resetFilters="resetFilters()">
          <div id="filter-info">
            <div
              class="button is-primary is-small column has-text-white is-radiusless has-text-centered has-text-weight-semibold"
              :class="loading ? 'is-loading is-fullwidth' : ''"
              style="min-height: 54px;">
              <span
                v-if="!loading"
                class="is-size-5">
                {{ tiersData.total }} tiers
                <br>
                {{ interlocuteursData.total }} interlocuteur<span v-if="interlocuteursData.total > 1">s</span>
              </span>
            </div>
          </div>
          <div class="is-padding">
            <div class="field">
              <div class="control">
                <v-input
                  id="searchable_name"
                  name="searchable_name"
                  :model="filters.searchable_name"
                  :errors-bag="errors"
                  :placeholder="'Raison sociale, email, téléphone...'"
                  @input="value => { filters.searchable_name = value; updateSimpleFilter() }">
                </v-input>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <multiselect
                  class="multiselect--option-ico"
                  v-model="filters.type"
                  label="label"
                  track-by="value"
                  :multiple="true"
                  :close-on-select="false"
                  :options="tiersTypes"
                  :searchable="true"
                  :show-labels="false"
                  :placeholder="''"
                  @input="updateSimpleFilter">
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Type(s) de tiers</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Type(s) ({{ values.length }})</span>
                  </span>
                  <span slot="noResult">Oups! Aucun type trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <v-input
                  id="interlocuteur"
                  name="interlocuteur"
                  :model="filters.interlocuteur"
                  :errors-bag="errors"
                  :placeholder="'Interlocuteur (nom, email...)'"
                  @input="value => { filters.interlocuteur = value; updateSimpleFilter() }">
                </v-input>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <v-input
                  id="address__city"
                  name="address__city"
                  :model="filters.address__city"
                  :errors-bag="errors"
                  :placeholder="'Ville'"
                  @input="value => { filters.address__city = value; updateSimpleFilter() }">
                </v-input>
              </div>
            </div>
            <div
              class="field"
              id="favorite-filter">
              <div class="control">
                <input
                  id="filter_favorite"
                  type="checkbox"
                  name="filter_favorite"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  :class="{'is-active' : filters.favorite}"
                  :checked="!!filters.favorite"
                  @change="filters.favorite = $event.target.checked || null; $event.target.blur(); updateSimpleFilter()">
                <label
                  class="is-size-6"
                  for="filter_favorite">Favoris</label>
              </div>
            </div>
          </div>
        </col-collapse-filter>
      </template>
      <tabs
        :links="tiersTabsLinks"
        :level="1"
        class="is-border-left is-border-right is-border-bottom" />
      <filters-tags
        class="is-border-left is-border-right"
        :has-filter="hasFilter"
        :filters="filters"
        :ignore-tags="['favorite']"
        @reset="resetFilters"
        @update="updateFromTag">
      </filters-tags>
      <div class="is-border-left is-border-right is-border-bottom">
        <router-view
          :key="$route.name"
          :source-items="activeData.items"
          :source-sort-by="sortBy"
          :loading="loading"
          :has-filter="hasFilter"
          @sort="sort"
          @reload="loadItems()"
          @reset="resetFilters()" />
        <pagination
          :loading="loading"
          :current-page="activeData.page"
          :total-page="activeData.pages"
          @changePage="loadItems($event)"></pagination>
      </div>
    </page-content>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'
import {
  DefaultValues,
  Error,
  Filter,
  Sort
} from '@/mixins'
import { TIERS_RESOURCE, INTERLOCUTEURS_RESOURCE, TIERS_TYPES } from './tiersConstants'

export default {
  name: 'TiersHome',
  mixins: [Filter, Sort, DefaultValues, Error],
  data () {
    return {
      loadDocuments: this.loadItems,
      tiersTypes: TIERS_TYPES,
      tiersTabsLinks: [
        { link: 'TiersList', label: 'Tiers' },
        { link: 'InterlocuteursList', label: 'Interlocuteurs' }
      ],
      loading: true,
      query: {},
      sortBy: {},
      perPage: 50,
      tiersData: { items: [], total: null, pages: null, page: null },
      interlocuteursData: { items: [], total: null, pages: null, page: null },
      filters: {
        searchable_name: null,
        type: [],
        interlocuteur: null,
        address__city: null,
        favorite: null
      },
      initFilters: {
        searchable_name: null,
        type: [],
        interlocuteur: null,
        address__city: null,
        favorite: null
      },
      openedCol: false
    }
  },
  computed: {
    ...mapState(['savedFilters']),
    activeData () {
      return this.$route.name === 'InterlocuteursList' ? this.interlocuteursData : this.tiersData
    }
  },
  created () {
    if (this.savedFilters.tiersList && this.savedFilters.tiersList.filters) {
      this.filters = cloneDeep(this.savedFilters.tiersList.filters)
    }
  },
  async mounted () {
    await this.loadItems()
  },
  methods: {
    /**
     * Charge les deux listes (tiers + interlocuteurs) avec les mêmes filtres,
     * comme StockVue charge programmes et lots
     * @param { Number } page - pagination de l'onglet actif
     */
    async loadItems (page = null) {
      this.loading = true
      this.query.per_page = this.perPage
      Object.keys(this.filters).forEach(key => {
        if (this.filters[key] !== null && (!Array.isArray(this.filters[key]) || this.filters[key].length > 0)) {
          if (Array.isArray(this.filters[key])) {
            this.query[key] = this.filters[key].map(item => item.pk || item.value || item)
          } else {
            this.query[key] = (typeof this.filters[key] === 'object' && this.filters[key].pk)
              ? this.filters[key].pk
              : this.filters[key]
          }
        } else {
          delete this.query[key]
        }
      })
      this.$store.commit('setSavedFilters', { from: 'tiersList', name: 'filters', value: cloneDeep(this.filters) })
      const activeTab = this.$route.name
      const tiersQuery = { ...this.query, page: (page && activeTab !== 'InterlocuteursList') ? page : 1 }
      const interlocuteursQuery = { ...this.query, page: (page && activeTab === 'InterlocuteursList') ? page : 1 }
      let { data: tiers } = await this.$api.get(TIERS_RESOURCE, tiersQuery)
      this.tiersData = { items: tiers.items, total: tiers.total, pages: tiers.pages, page: tiers.page }
      let { data: interlocuteurs } = await this.$api.get(INTERLOCUTEURS_RESOURCE, interlocuteursQuery)
      this.interlocuteursData = { items: interlocuteurs.items, total: interlocuteurs.total, pages: interlocuteurs.pages, page: interlocuteurs.page }
      this.loading = false
      this.$store.dispatch('scrollToLastEl')
    }
  }
}
</script>
